import { Box, CircularProgress, Typography } from "@mui/material";
import { SELECT_COLOR } from "./selectConstants";

/**
 * Empty state inside an open selector list.
 * `options === null` means this filter's values are still loading.
 * An array, including an empty one, means loading is finished.
 * Callers that always pass an array never show the spinner.
 */
export default function SelectorOptionsMessage({ options, hasVisibleOptions }) {
  if (options !== null && hasVisibleOptions === true) {
    return null;
  }

  if (options === null) {
    return (
      <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
        <CircularProgress size={22} sx={{ color: SELECT_COLOR }} aria-label="Loading filter values" />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, textAlign: "center" }}>
      <Typography variant="body2" color="textSecondary">
        No options found
      </Typography>
    </Box>
  );
}
